export enum BasemapProviderEnum {
  GOOGLE = 'google',
  BING = 'bing',
  ARCGIS = 'arcgis',
  OSM = 'osm',
  ESRI = 'esri',
  CARTODB = 'cartodb',
  STAMEN = 'stamen',
  OTHER = 'other',
}
